/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Table, Panel, IconButton, Icon, FlexboxGrid, Button } from 'rsuite'
import AreaCell from '../../elements/cellstable/AreaCell'
import DateCell from '../../elements/cellstable/DateCell'
import OrderIDCell from '../../elements/cellstable/OrderID'
import PriceCell from '../../elements/cellstable/PriceCell'
import StatusCell from '../../elements/cellstable/StatusCell'
import API from '../../../api'
import { SatImgContext } from '../../../contexts/DataProviderContext'
import { set } from 'date-fns'
import { SearchOptionsContext } from '../../../contexts/SearchDetailsContext'
import { HOST_URL } from '../../../constants/constants'
import FlexboxGridItem from 'rsuite/lib/FlexboxGrid/FlexboxGridItem'
import axios from 'axios'

const OrdersTable = ({ rowData, dataKey, data, height, ...props }) => {
  /* eslint-disable */
    const LZString = (function () { function o (o, r) { if (!t[o]) { t[o] = {}; for (let n = 0; n < o.length; n++) { t[o][o.charAt(n)] = n } } return t[o][r] } const r = String.fromCharCode; const n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='; const e = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$'; var t = {}; var i = { compressToBase64: function (o) { if (o == null) { return '' } const r = i._compress(o, 6, function (o) { return n.charAt(o) }); switch (r.length % 4) { default: case 0: return r; case 1: return r + '==='; case 2: return r + '=='; case 3: return r + '=' } }, decompressFromBase64: function (r) { return r == null ? '' : r == '' ? null : i._decompress(r.length, 32, function (e) { return o(n, r.charAt(e)) }) }, compressToUTF16: function (o) { return o == null ? '' : i._compress(o, 15, function (o) { return r(o + 32) }) + ' ' }, decompressFromUTF16: function (o) { return o == null ? '' : o == '' ? null : i._decompress(o.length, 16384, function (r) { return o.charCodeAt(r) - 32 }) }, compressToUint8Array: function (o) { for (var r = i.compress(o), n = new Uint8Array(2 * r.length), e = 0, t = r.length; t > e; e++) { const s = r.charCodeAt(e); n[2 * e] = s >>> 8, n[2 * e + 1] = s % 256 } return n }, decompressFromUint8Array: function (o) { if (o === null || void 0 === o) { return i.decompress(o) } for (var n = new Array(o.length / 2), e = 0, t = n.length; t > e; e++) { n[e] = 256 * o[2 * e] + o[2 * e + 1] } const s = []; return n.forEach(function (o) { s.push(r(o)) }), i.decompress(s.join('')) }, compressToEncodedURIComponent: function (o) { return o == null ? '' : i._compress(o, 6, function (o) { return e.charAt(o) }) }, decompressFromEncodedURIComponent: function (r) { return r == null ? '' : r == '' ? null : (r = r.replace(/ /g, '+'), i._decompress(r.length, 32, function (n) { return o(e, r.charAt(n)) })) }, compress: function (o) { return i._compress(o, 16, function (o) { return r(o) }) }, _compress: function (o, r, n) { if (o == null) { return '' } let e; let t; let i; const s = {}; const p = {}; let u = ''; let c = ''; let a = ''; let l = 2; let f = 3; let h = 2; const d = []; let m = 0; let v = 0; for (i = 0; i < o.length; i += 1) { if (u = o.charAt(i), Object.prototype.hasOwnProperty.call(s, u) || (s[u] = f++, p[u] = !0), c = a + u, Object.prototype.hasOwnProperty.call(s, c)) { a = c } else { if (Object.prototype.hasOwnProperty.call(p, a)) { if (a.charCodeAt(0) < 256) { for (e = 0; h > e; e++) { m <<= 1, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++ } for (t = a.charCodeAt(0), e = 0; e < 8; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } } else { for (t = 1, e = 0; h > e; e++) { m = m << 1 | t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t = 0 } for (t = a.charCodeAt(0), e = 0; e < 16; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), delete p[a] } else { for (t = s[a], e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), s[c] = f++, a = String(u) } } if (a !== '') { if (Object.prototype.hasOwnProperty.call(p, a)) { if (a.charCodeAt(0) < 256) { for (e = 0; h > e; e++) { m <<= 1, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++ } for (t = a.charCodeAt(0), e = 0; e < 8; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } } else { for (t = 1, e = 0; h > e; e++) { m = m << 1 | t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t = 0 } for (t = a.charCodeAt(0), e = 0; e < 16; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++), delete p[a] } else { for (t = s[a], e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } }l--, l == 0 && (l = Math.pow(2, h), h++) } for (t = 2, e = 0; h > e; e++) { m = m << 1 | 1 & t, v == r - 1 ? (v = 0, d.push(n(m)), m = 0) : v++, t >>= 1 } for (;;) { if (m <<= 1, v == r - 1) { d.push(n(m)); break }v++ } return d.join('') }, decompress: function (o) { return o == null ? '' : o == '' ? null : i._decompress(o.length, 32768, function (r) { return o.charCodeAt(r) }) }, _decompress: function (o, n, e) { let t; let i; let s; let p; let u; let c; let a; let l; const f = []; let h = 4; let d = 4; let m = 3; let v = ''; const w = []; const A = { val: e(0), position: n, index: 1 }; for (i = 0; i < 3; i += 1) { f[i] = i } for (p = 0, c = Math.pow(2, 2), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 } switch (t = p) { case 0: for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }l = r(p); break; case 1: for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }l = r(p); break; case 2: return '' } for (f[3] = l, s = l, w.push(l); ;) { if (A.index > o) { return '' } for (p = 0, c = Math.pow(2, m), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 } switch (l = p) { case 0: for (p = 0, c = Math.pow(2, 8), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }f[d++] = r(p), l = d - 1, h--; break; case 1: for (p = 0, c = Math.pow(2, 16), a = 1; a != c;) { u = A.val & A.position, A.position >>= 1, A.position == 0 && (A.position = n, A.val = e(A.index++)), p |= (u > 0 ? 1 : 0) * a, a <<= 1 }f[d++] = r(p), l = d - 1, h--; break; case 2: return w.join('') } if (h == 0 && (h = Math.pow(2, m), m++), f[l]) { v = f[l] } else { if (l !== d) { return null }v = s + s.charAt(0) }w.push(v), f[d++] = s + v.charAt(0), h--, s = v, h == 0 && (h = Math.pow(2, m), m++) } } }; return i }()); typeof define == 'function'
    /* eslint-enable */
  function encodeParams (params) {
    if (params === undefined || params === null) { return '' }

    if (typeof params !== 'object') { return '' + params }

    const result = []

    for (const name in params) {
      if (name) {
        result.push(name + '=' + encodeURIComponent(encodeParams(params[name])))
      }
    }

    return result.join('&')
  }
  const createPaymentObject = function (auth, invoiceId, amount, terminalID, postLink, currency) {
    const user = JSON.parse(localStorage.user)
    const paymentObject = {
      invoiceId,
      backLink: 'https://example.kz/success.html',
      failureBackLink: 'https://example.kz/failure.html',
      postLink,
      failurePostLink: 'https://example.kz/order/1123/fail',
      language: 'rus',
      description: 'Оплата в KGS',
      // accountId: user.email,
      terminal: terminalID,
      amount,
      currency,
      cardSave: true,
      email: user.email,
      phone: user.phone
    }
    paymentObject.auth = auth
    return paymentObject
  }
  const { t } = useTranslation()
  const [array1, setArray] = useState([])
  const { dataTiles, setDataTiles, setdetails } = useContext(SatImgContext)
  const { jsonLayers, setJsonLayers, searchOptions, setSearchOptions } = useContext(SearchOptionsContext)
  const { Column, HeaderCell, Cell } = Table
  const rowKey = 'id'
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [orderId, setOrderId] = useState(0)
  const [orderScenes, setOrderScenes] = useState([])
  const [details, setDetails] = useState({})
  const [defheight, setDefheight] = useState(100)
  const [numOrder, setnumOrder] = useState(0)
  const [infoShow, setInfoshow] = useState(false)
  const [orderInfo, setOrderInfo] = useState({})
  const Orders = () => {
    return (
        <>
        </>
    )
  }
  const handleBuyClick = async () => {
    const token = await API.order.get_payment_token(orderId)
    console.log(token)
    const params = createPaymentObject(
      {
        access_token: token.access_token,
        expires_in: token.expires_in,
        refresh_token: token.refresh_token,
        scope: token.scope,
        token_type: token.token_type
      },
      token.invoiceId, token.amount, token.terminal, token.postLink, token.currency)
    console.log(params)
    window.open(`https://epay.homebank.kz/payform?params=${LZString.compressToEncodedURIComponent(encodeParams(params))}`)
  }
  const ExpandCell = ({ rowData, dataKey, expandedRowKeys, onChange, ...props }) => (
    <Cell {...props} onClick={() => {
      onChange(rowData)
    }}>
      <IconButton
        size='xs'
        appearance='subtle'
        icon={
          <Icon
            icon={
              expandedRowKeys.some(key => key === rowData[rowKey])
                ? 'minus-square-o'
                : 'plus-square-o'
            }
          />
        }
      />
    </Cell>
  )
  const modalClose = () => {
    setInfoshow(false)
  }
  const handleExpanded = (rowData, dataKey) => {
    if (orderId !== rowData.id) {
      setArray(() => [])
      setOrderId(rowData.id)
    }
    setInfoshow(true)
    console.log(infoShow)
    // if (rowData[rowKey] === expandedRowKeys[0]) {
    //   setExpandedRowKeys([])
    // } else {
    //   setExpandedRowKeys([rowData[rowKey]])
    // }
  }

  // TODO: Add checking manager and RETHINK
  // FIXME: save all image results
  useEffect(() => {
    const fetchData = async () => {
      const result = await API.order.get_user_order(orderId)
      setOrderInfo(() => result.order)
      setOrderScenes(() => result.order.images)
    }
    orderId && fetchData()
  }, [orderId])
  // Moving through all images ion order
  useEffect(() => {
    orderScenes.map(item => {
      const fetchData = async () => {
        if (item.code !== null) {
          const result = await API.scenes.by_code(item.code)
          setArray(array1 => [...array1, { ...result.area, order_display_id: numOrder }])
        } else {
          setArray(array1 => [...array1, { ...item, order_display_id: numOrder }])
        }
      }
      item.code && fetchData()
    })
  }, [orderScenes])
  return (
      <>
      <Modal id="img-show" show={infoShow} keyboard={true} backdrop={true} style={{ height: '90vh' }}>
      <IconButton onClick={modalClose} appearance='ghost' size='sm' on icon={<Icon icon='close' />} />
      <Modal.Header closeButton={false}>
          <Modal.Title className='text-center'>
            {t('Order.Popup.title') + orderId}:
          </Modal.Title>
          <p className="info-entry2"> {t('Order.Popup.total')} {array1.length}</p>
          <p className="info-entry2"> {t('Order.Popup.priceusd')} {orderInfo.price_usd}</p>
          <p className="info-entry2">{t('Order.Popup.pricekzt')} {orderInfo.price_kzt}</p>
          <p className="info-entry2" style={{
            color: orderInfo.is_done
              ? 'green'
              : orderInfo.is_canceled
                ? 'red'
                : 'orange'
          }}>{t('Order.Popup.stage')} {orderInfo.is_done ? t('Order.Status.done') : orderInfo.is_canceled ? t('Order.Status.cancelled') : t('Order.Status.processing')}</p><br />
          <Button appearance='primary' onClick={handleBuyClick}>Оплатить</Button>
          <p className="info-entry2">{orderInfo.is_done ? `${t('Order.Popup.response')}  ${orderInfo.response.response}` : ''}</p>
        </Modal.Header>
        <div className="order-cell">
          {array1.map((order, index) => {
            if (order.satellite) {
              return (
              <div key={index + 1}>
              <div className="infolist">
              <p className="info-entry">({t('Order.Popup.scene')} {index + 1} / {array1.length}) ID: {order.id}</p>
              <p className="info-entry">{t('Scene.satellite')} {order.satellite}</p>
              <p className="info-entry">{t('Common.date')} {order.created_at}</p>
              </div>
              <img style={{ height: '100%', float: 'left', width: '18%' }} src={order.quicklook_url[0] === 'h' ? order.quicklook_url : HOST_URL + order.quicklook_url}></img>
              </div>)
            } else {
              return (
                <div key={index + 1}>
                <div className="infolist">
                <p className="info-entry">({t('Order.Popup.scene')} {index + 1} / {array1.length}) ID: {order.id}</p>
                <p className="info-entry">Цель съемки: {order.application_theme}</p>
                <p className="info-entry">Разрешение: {order.resolution}</p>
                <p className="info-entry">Уровень обработки: {order.processing_level}</p>
                <p className="info-entry">Приоритет: {order.priority}</p>
                <p className="info-entry">Начало: {order.periods[0].start}</p>
                <p className="info-entry">Конец {order.periods[0].end}</p>
                <p className="info-entry">Облачное покрытие: {order.cloud_cover}</p>
                <p className="info-entry">Ролл: {order.roll}</p>
                <p className="info-entry">Питч: {order.pitch}</p>
                <p className="info-entry">Вертикальный наклон {order.yaw}</p>
                <p className="info-entry">{t('Common.date')} {order.created_at}</p>
                </div>
                </div>)
            }
          })
        }
        </div>
    </Modal>
    <Panel bodyFill>
      <Table
        virtualized
        data={data}
        id='table'
        rowKey={rowKey}
        height={height}
        rowHeight={60}
        // TODO: Added centering map and ectention for scenes
        expandedRowKeys={expandedRowKeys}
        renderRowExpanded={rowData => {
          return (
            <Orders/>
          )
        }
      }
      >

        <Column minwidth={10} flexGrow={1} align='left'>
          <HeaderCell>{t('Common.id')}</HeaderCell>
          {/* <Cell dataKey='id'>{data.id}</Cell> */}
          <OrderIDCell dataKey='id' />
        </Column>

        <Column minwidth={10} flexGrow={2} align='left'>
          <HeaderCell>{t('Common.status')}</HeaderCell>
          <StatusCell dataKey='id' />
        </Column>

        <Column minwidth={10} flexGrow={1} align='left'>
          <HeaderCell>{t('Common.date')}</HeaderCell>
          <DateCell dataKey='id' />
        </Column>

        <Column width={70} align='center'>
          <HeaderCell>#</HeaderCell>
          <ExpandCell
            dataKey='id'
            expandedRowKeys={expandedRowKeys}
            onChange={handleExpanded}
          />
        </Column>
        {/* <Column minwidth={10} flexGrow={1} align='left'>
          <HeaderCell>{t('Common.area')}</HeaderCell>
          <AreaCell dataKey='id' />
        </Column>

        <Column minwidth={10} flexGrow={1} align='left' fixed>
          <HeaderCell>{t('Common.price')}</HeaderCell>
          <PriceCell dataKey='id' />
        </Column> }

        {/* <Column minwidth={300} flexGrow={1} align='left' fixed>
          <HeaderCell>{t('Common.name')}</HeaderCell>
          <NameCell dataKey='id' isActive={isActive} detailsID={data.id} />
        </Column> */}

      </Table>
    </Panel>
    </>
  )
}

export default OrdersTable
